import React from 'react';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';

interface FloatingInputProps {
  id: string;
  name: string;
  type?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  autoComplete?: string;
  showPasswordToggle?: boolean;
  showPassword?: boolean;
  setShowPassword?: (value: React.SetStateAction<boolean>) => void;
  noBottomMargin?: boolean;
}

const FloatingInput: React.FC<FloatingInputProps> = ({
  id,
  name,
  type = 'text',
  value,
  onChange,
  placeholder,
  autoComplete,
  showPasswordToggle,
  showPassword,
  setShowPassword,
  noBottomMargin = false,
}) => {
  const isActive = value && value.length > 0;
  return (
    <div className={`relative w-full max-w-[570px] ${noBottomMargin ? '' : 'mb-8'}`}>
      <input
        id={id}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        className={`w-full border-0 border-b-2 border-gray-300 focus:border-[#333] bg-white text-[14px] placeholder-transparent font-['Plus Jakarta Sans'] text-[#667085] py-4 px-0 outline-none transition-all peer`}
        style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}
        placeholder={placeholder}
      />
      <label
        htmlFor={id}
        className={`absolute left-0 text-[14px] text-[#667085] font-medium pointer-events-none transition-all duration-200 ml-0
          ${isActive ? 'top-0 -translate-y-1 text-xs text-[#333] font-semibold' : 'top-1/2 -translate-y-1/2 peer-focus:top-0 peer-focus:-translate-y-1 peer-focus:text-xs peer-focus:text-[#333] peer-focus:font-semibold'}`}
        style={{ 
          background: 'white', 
          padding: isActive ? '0 4px' : '0',
          transition: 'all 0.2s ease-in-out'
        }}
      >
        {placeholder}
      </label>
      {showPasswordToggle && setShowPassword && (
        <button
          type="button"
          tabIndex={-1}
          className="absolute right-0 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700"
          onClick={() => setShowPassword((v) => !v)}
        >
          {showPassword ? (
            <EyeSlashIcon className="h-5 w-5" />
          ) : (
            <EyeIcon className="h-5 w-5" />
          )}
        </button>
      )}
    </div>
  );
};

export default FloatingInput; 